// Nirvana Default dashboard layout — the reset target for every user.
import { SIZE_PRESETS } from "@/lib/widgets";

// instance id = widget type for the default layout (unique per type here).
const DEFAULT_WIDGETS = [
  "needs_attention", "overdue", "ready_to_publish", "upcoming",
  "recent_activity", "team_members", "strong_performers", "new_opportunities",
  "system_health",
];

const SIZE_FOR = {
  needs_attention: "medium", overdue: "small", ready_to_publish: "medium", upcoming: "medium",
  recent_activity: "medium", team_members: "small", strong_performers: "medium",
  new_opportunities: "medium", system_health: "small",
};

function buildDefault() {
  const widgets = {};
  const desktop = [];
  const mobile = [];
  let dx = 0, dy = 0, rowH = 0, my = 0;
  DEFAULT_WIDGETS.forEach((type) => {
    const size = SIZE_FOR[type] || "medium";
    const p = SIZE_PRESETS[size];
    widgets[type] = { type, config: {}, collapsed: false, hidden: false, size };
    // desktop flow packing across 12 cols
    if (dx + p.w > 12) { dx = 0; dy += rowH; rowH = 0; }
    desktop.push({ i: type, x: dx, y: dy, w: p.w, h: p.h });
    dx += p.w; rowH = Math.max(rowH, p.h);
    // mobile: single column stack
    mobile.push({ i: type, x: 0, y: my, w: 4, h: p.mH });
    my += p.mH;
  });
  return { widgets, desktop, mobile, source: "default" };
}

export const NIRVANA_DEFAULT = buildDefault();

export function cloneDefault() {
  return JSON.parse(JSON.stringify(NIRVANA_DEFAULT));
}
